import { Apartment, Bolt, Construction, Home, Receipt, Shower, Wifi } from "@mui/icons-material";
import {
  BusSchedulesType,
  BusStopListMapType,
  BusStopTimesType,
  ScheduleRulesType,
} from "../types/bus";
import { TopicMappingType } from "../types/common";

export const Constants = {
  BillIcon: ({ ...props }) => {
    const { name, ...other } = props;

    switch (name) {
      case "ap":
        return <Apartment {...other} />;
      case "home":
        return <Home {...other} />;
      case "fix":
        return <Construction {...other} />;
      case "internet":
        return <Wifi {...other} />;
      case "water":
        return <Shower {...other} />;
      case "light":
        return <Bolt {...other} />;
      default:
        return <Receipt {...other} />;
    }
  },

  monthMap: (number: string | number, isShort: boolean = false) => {
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    const month = months[parseInt(String(number))];
    return isShort ? month.slice(0, 3) : month;
  },

  toPrice: (value: string | number, withSign: boolean = true) => {
    return `R$ ${parseFloat(String(value)).toFixed(2).replace(".", ",")}`;
  },

  cafeteriaSpots: [
    { name: "UFRN", value: "ufrn" },
    { name: "IMD", value: "imd" },
    { name: "C&T", value: "cet" },
    { name: "Reitoria", value: "rei" },
    { name: "DEART", value: "deart" },
    { name: "DEF", value: "def" },
    { name: "Dep. Música", value: "dmus" },
    { name: "Geologia", value: "geo" },
    { name: "CB", value: "cb" },
    { name: "Setor I", value: "set1" },
    { name: "Setor II", value: "set2" },
    { name: "Setor III", value: "set3" },
    { name: "Setor IV", value: "set4" },
    { name: "Setor V", value: "set5" },
  ],

  busStopListMap: {
    via: { name: "Via Direta", shortName: "Via" },
    cet: { name: "C&T", shortName: "C&T" },
    rei: { name: "Reitoria", shortName: "Reitoria" },
    imd: { name: "IMD/Residência", shortName: "IMD" },
    ccsa: { name: "CCSA - Setor I & V", shortName: "CCSA" },
    cchla: { name: "CCHLA/CE - Setor II", shortName: "CCHLA/CE" },
    cb: { name: "CB - Morfologia", shortName: "CB" },
    fisio: { name: "Fisio/Piscina", shortName: "Fisio" },
    geo: { name: "Geologia", shortName: "Geo" },
    petr: { name: "Lab. Petróleo", shortName: "Petróleo" },
    nu: { name: "NUPLAN", shortName: "NUPLAN" },
    edit: { name: "Editora", shortName: "Editora" },
    poti: { name: "Potilândia", shortName: "Poti" },
    gin: { name: "Ginásio Mirassol", shortName: "Ginásio" },
    igre: { name: "Igreja Mirassol", shortName: "Igreja" },
    deart: { name: "DEART", shortName: "DEART" },
    mus: { name: "Esc. Música", shortName: "Música" },
    def: { name: "DEF", shortName: "DEF" },
    por: { name: "Portão 2", shortName: "Portão" },
    ru: { name: "Terminal RU", shortName: "RU" },
  } as BusStopListMapType,

  busStopSchedule: [
    {
      id: "direto",
      name: "Direto",
      schedule: [
        "ru",
        "fisio",
        "ccsa",
        "cchla",
        "geo",
        "petr",
        "cet",
        "cb",
        "nu",
        "edit",
        "por",
        "gin",
        "igre",
        "via",
        "deart",
        "mus",
        "rei",
        "def",
        "ru",
      ],
    },
    {
      id: "inverso",
      name: "Inverso",
      schedule: [
        "ru",
        "def",
        "rei",
        "edit",
        "por",
        "gin",
        "igre",
        "via",
        "deart",
        "mus",
        "cb",
        "cet",
        "petr",
        "geo",
        "cchla",
        "ccsa",
        "fisio",
        "poti",
        "imd",
        "ru",
      ],
    },
    {
      id: "cet",
      name: "Expresso C&T",
      schedule: ["cet", "via", "cet"],
    },
    {
      id: "reitoria",
      name: "Expresso Reitoria",
      schedule: ["rei", "via", "rei"],
    },
  ],

  busStopTimes: {
    via: {
      "direto-default": "13",
      "semana-ferias": "13",
      "sexta-ferias": "13",
      "sabado-ferias": "13",
      "inverso-default": "7",
      "sabado-default": "12",
    },
    cet: {
      "direto-default": "6",
      "semana-ferias": "6",
      "sexta-ferias": "6",
      "sabado-ferias": "6",
      "inverso-default": "15",
      "cet-default": "5",
      "sabado-default": "5",
    },
    rei: {
      "direto-default": "21",
      "semana-ferias": "21",
      "sexta-ferias": "21",
      "sabado-ferias": "21",
      "inverso-default": "2",
      "reitoria-default": "5",
      "sabado-default": "18",
    },
    imd: {
      "inverso-default": "21",
    },
    fisio: {
      "direto-default": "1",
      "semana-ferias": "1",
      "sexta-ferias": "1",
      "sabado-ferias": "1",
      "inverso-default": "20",
      "sabado-default": "1",
    },
    ccsa: {
      "direto-default": "2",
      "semana-ferias": "2",
      "sexta-ferias": "2",
      "sabado-ferias": "2",
      "inverso-default": "19",
      "sabado-default": "2",
    },
    cchla: {
      "direto-default": "3",
      "semana-ferias": "3",
      "sexta-ferias": "3",
      "sabado-ferias": "3",
      "inverso-default": "18",
      "sabado-default": "3",
    },
    geo: {
      "direto-default": "4",
      "semana-ferias": "4",
      "sexta-ferias": "4",
      "sabado-ferias": "4",
      "inverso-default": "17",
      "sabado-default": "4",
    },
    petr: {
      "direto-default": "5",
      "semana-ferias": "5",
      "sexta-ferias": "5",
      "sabado-ferias": "5",
      "inverso-default": "16",
      "sabado-default": "5",
    },
    cb: {
      "direto-default": "8",
      "semana-ferias": "8",
      "sexta-ferias": "8",
      "sabado-ferias": "8",
      "inverso-default": "13",
      "sabado-default": "6",
    },
    nu: {
      "direto-default": "9",
      "semana-ferias": "9",
      "sexta-ferias": "9",
      "sabado-ferias": "9",
      "inverso-default": "9",
      "sabado-default": "6",
    },
    edit: {
      "direto-default": "10",
      "semana-ferias": "10",
      "sexta-ferias": "10",
      "sabado-ferias": "10",
      "inverso-default": "4",
      "sabado-default": "7",
    },
    gin: {
      "direto-default": "11",
      "semana-ferias": "11",
      "sexta-ferias": "11",
      "sabado-ferias": "11",
      "inverso-default": "5",
      "sabado-default": "8",
    },
    igre: {
      "direto-default": "11",
      "semana-ferias": "11",
      "sexta-ferias": "11",
      "sabado-ferias": "11",
      "inverso-default": "6",
      "sabado-default": "9",
    },
    deart: {
      "direto-default": "17",
      "semana-ferias": "17",
      "sexta-ferias": "17",
      "sabado-ferias": "17",
      "inverso-default": "10",
      "sabado-default": "16",
    },
    mus: {
      "direto-default": "19",
      "semana-ferias": "19",
      "sexta-ferias": "19",
      "sabado-ferias": "19",
      "inverso-default": "12",
      "sabado-default": "17",
    },
    def: {
      "direto-default": "23",
      "semana-ferias": "23",
      "sexta-ferias": "23",
      "sabado-ferias": "23",
      "inverso-default": "1",
      "sabado-default": "19",
    },
  } as BusStopTimesType,

  busSchedules: {
    "cet-default": {
      color: "cet",
      name: "Expresso C&T",
      shortName: "C&T",
      schedule: {
        "6": {
          "35": {},
          "45": {},
          "55": {},
        },
        "7": {
          "5": {},
          "15": {},
          "25": {},
          "45": {},
        },
        "8": {
          "5": {},
          "15": {},
          "25": {},
          "35": {},
          "45": {},
          "55": { ru: true },
        },
        "9": {
          "5": {},
          "25": {},
          "45": {},
        },
        "10": {
          "5": { ru: true },
          "15": { terminal: true },
          "35": {},
          "55": {},
        },
        "11": {
          "15": { ru: true },
          "25": { terminal: true },
          "45": {},
          "55": { terminal: true },
        },
        "12": {
          "5": {},
          "15": {},
          "25": { ru: true },
          "35": {},
          "45": { terminal: true },
          "55": { ru: true },
        },
        "13": {
          "5": {},
          "15": { terminal: true },
          "25": {},
          "45": {},
        },
        "14": {
          "5": {},
          "25": {},
          "35": {},
          "45": {},
        },
        "15": {
          "5": {},
          "25": {},
          "35": { ru: true },
          "45": {},
        },
        "16": {
          "5": {},
          "25": {},
          "45": {},
          "55": { terminal: true },
        },
        "17": {
          "5": {},
          "15": {},
          "25": {},
          "35": {},
          "45": {},
          "55": {},
        },
        "18": {
          "5": {},
          "15": {},
          "25": {},
          "35": {},
          "45": {},
          "55": { ru: true },
        },
        "19": {
          "5": {},
          "25": { ru: true },
          "35": { terminal: true },
          "55": {},
        },
        "20": {
          "15": {},
          "35": {},
          "45": { terminal: true },
          "55": {},
        },
        "21": {
          "5": {},
          "15": {},
          "25": {},
          "35": {},
          "45": {},
          "55": {},
        },
        "22": {
          "5": {},
          "15": {},
          "25": {},
        },
      },
    },

    "reitoria-default": {
      color: "reitoria",
      name: "Expresso Reitoria",
      shortName: "Reitoria",
      schedule: {
        "6": {
          "30": {},
          "40": {},
          "50": {},
        },
        "7": {
          "0": {},
          "10": {},
          "20": {},
          "30": {},
          "40": {},
          "50": {},
        },
        "8": {
          "0": {},
          "10": {},
          "20": {},
          "30": {},
          "40": {},
          "50": { ru: true },
        },
        "9": {
          "0": {},
          "20": {},
          "40": {},
        },
        "10": {
          "0": { ru: true },

          "20": {},
          "40": {},
        },
        "11": {
          "0": {},
          "20": { ru: true },

          "40": {},
          "55": { terminal: true },
        },
        "12": {
          "0": {},
          "10": { ru: true },
          "20": {},
          "30": { terminal: true },
          "40": {},
          "50": { ru: true },
        },
        "13": {
          "0": {},
          "10": { terminal: true },
          "20": {},
          "30": {},
          "40": {},
          "50": {},
        },
        "14": {
          "0": {},
          "20": {},
          "40": {},
        },
        "15": {
          "0": {},
          "10": {},
          "20": {},
          "30": {},
          "50": {},
        },
        "16": {
          "10": {},
          "30": {},
          "40": {},
          "50": {},
        },
        "17": {
          "0": {},
          "10": {},
          "20": {},
          "30": {},
          "40": {},
          "50": {},
        },
        "18": {
          "0": {},
          "10": {},
          "20": {},
          "30": {},
          "40": {},
          "50": {},
        },
        "19": {
          "0": {},
          "20": {},
          "30": {},
          "40": {},
        },
        "20": {
          "0": {},
          "10": {},
          "20": {},
          "30": {},
          "40": {},
        },
      },
    },

    "direto-default": {
      color: "direto",
      name: "Direto",
      shortName: "Direto",
      schedule: {
        "6": {
          "15": { company: "Guanabara" },
          "20": { company: "ViaSul" },
          "40": { company: "Guanabara" },
        },
        "7": {
          "0": { company: "ViaSul" },
          "20": { company: "Guanabara" },
          "30": { company: "ViaSul" },
        },
        "8": {
          "0": { company: "ViaSul" },
          "30": { company: "ViaSul" },
        },
        "9": {
          "0": { company: "Guanabara" },
          "30": { company: "Guanabara" },
        },
        "10": {
          "0": { company: "Guanabara" },
          "10": { company: "ViaSul" },
          "30": { company: "Guanabara" },
        },
        "11": {
          "0": { company: "ViaSul" },
          "20": { company: "Guanabara" },
          "30": { company: "ViaSul" },
          "50": { company: "Guanabara" },
        },
        "12": {
          "05": { company: "ViaSul" },
          "25": { company: "Guanabara" },
          "50": { company: "ViaSul" },
        },
        "13": {
          "10": { company: "Guanabara" },
          "30": { company: "ViaSul" },
        },
        "14": {
          "0": { company: "Guanabara" },
          "30": { company: "ViaSul" },
        },
        "15": {
          "0": { company: "Guanabara" },
          "30": { company: "ViaSul" },
        },
        "16": {
          "10": { company: "ViaSul" },
          "40": { company: "Guanabara" },
        },
        "17": {
          "20": { company: "Guanabara" },
          "40": { company: "ViaSul" },
        },
        "18": {
          "0": { company: "Guanabara" },
          "20": { company: "ViaSul" },
          "40": { company: "Guanabara" },
        },
        "19": {
          "0": { company: "ViaSul" },
          "20": { company: "Guanabara" },
          "50": { company: "ViaSul" },
        },
        "20": {
          "10": { company: "Guanabara" },
          "30": { company: "ViaSul" },
          "40": { company: "Guanabara" },
        },
        "21": {
          "10": { company: "ViaSul" },
          "30": { company: "Guanabara" },
          "45": { company: "ViaSul" },
        },
        "22": {
          "0": { company: "Guanabara" },
          "20": { company: "ViaSul" },
        },
      },
    },

    "inverso-default": {
      color: "inverso",
      name: "Inverso",
      shortName: "Inverso",
      schedule: {
        "6": {
          "30": { company: "Natal" },
          "31": { company: "Conceição" },
          "50": { company: "Conceição" },
        },
        "7": {
          "10": { company: "Natal" },
          "30": { company: "Conceição" },
          "50": { company: "Natal" },
        },
        "8": {
          "10": { company: "Conceição" },
          "40": { company: "Natal" },
        },
        "9": {
          "10": { company: "Natal" },
          "40": { company: "Conceição" },
        },
        "10": {
          "10": { company: "Conceição" },
          "40": { company: "Natal" },
        },
        "11": {
          "0": { company: "Conceição" },
          "20": { company: "Natal" },
        },
        "12": {
          "0": { company: "Natal" },
          "15": { company: "Conceição" },
          "35": { company: "Natal" },
          "50": { company: "Conceição" },
        },
        "13": {
          "10": { company: "Natal" },
          "30": { company: "Conceição" },
          "40": { company: "Natal" },
        },
        "14": {
          "20": { company: "Conceição" },
          "40": { company: "Natal" },
        },
        "15": {
          "0": { company: "Conceição" },
          "30": { company: "Natal" },
        },
        "16": {
          "0": { company: "Conceição" },
          "30": { company: "Natal" },
          "50": { company: "Conceição" },
        },
        "17": {
          "10": { company: "Natal" },
          "30": { company: "Conceição" },
          "50": { company: "Natal" },
        },
        "18": {
          "10": { company: "Conceição" },
          "30": { company: "Natal" },
          "50": { company: "Conceição" },
        },
        "19": {
          "30": { company: "Conceição" },
        },
        "20": {
          "10": { company: "Natal" },
          "40": { company: "Natal" },
        },
        "21": {
          "10": { company: "Conceição" },
          "20": { company: "Natal" },
          "40": { company: "Conceição" },
          "50": { company: "Natal" },
        },
        "22": {
          "10": { company: "Conceição" },
          "20": { company: "Natal" },
        },
      },
    },

    "sabado-default": {
      color: "direto",
      name: "Direto - Sábado",
      shortName: "Direto",
      schedule: {
        "6": { "15": {}, "45": {} },
        "7": { "15": {}, "45": {} },
        "8": { "15": {}, "45": {} },
        "9": { "15": {}, "45": {} },
        "10": { "15": {} },
        "11": { "45": {} },
        "12": { "15": {}, "45": {} },
        "13": { "15": {}, "45": {} },
        "14": { "15": {} },
      },
    },
  } as BusSchedulesType,

  busRules: {
    default: {
      name: "Horário Normal",
      days: {
        "0": [],
        "1": ["cet-default", "reitoria-default", "direto-default", "inverso-default"],
        "2": ["cet-default", "reitoria-default", "direto-default", "inverso-default"],
        "3": ["cet-default", "reitoria-default", "direto-default", "inverso-default"],
        "4": ["cet-default", "reitoria-default", "direto-default", "inverso-default"],
        "5": ["cet-default", "reitoria-default", "direto-default", "inverso-default"],
        "6": ["sabado-default"],
      },
    },
  } as ScheduleRulesType,

  publicTopics: [
    { topic: "public-general", name: "Tópico Geral" },
    { topic: "public-new-post", name: "Nova Postagem" },
  ] as TopicMappingType[],

  privateTopics: [
    { topic: "admin-general", name: "Tópico Administrador" },
    { topic: "admin-update-menu", name: "Cardápio Atualizado" },
    { topic: "admin-chat-message", name: "Nova Mensagem no Chat" },
    { topic: "admin-new-user", name: "Novo Usuário" },
    { topic: "admin-new-post", name: "Nova Postagem" },
    { topic: "admin-new-cafeteria", name: "Nova Lanchonete" },
    { topic: "admin-config-update", name: "Configurações Atualizadas" },
  ] as TopicMappingType[],
};
